// @flow

import React from 'react'
import styled from 'styled-components'
import Post from './Post'

type BlogPost = {
    id: string,
    title: string,
    summary: string,
    author: string,
    url: string,
    userImageURL: string,
}

type Props = {
    posts: Array<BlogPost>,
}

const UnstyledBlogPosts = ({ posts, ...props }: Props) => (
    <div {...props}>
        {(posts || []).map(({
            id,
            title,
            summary,
            author,
            url,
            userImageURL,
        }) => (
            <div key={id}>
                <Post
                    $appear
                    url={url}
                    title={title}
                    author={author}
                    userImageUrl={userImageURL}
                >
                    {summary}
                </Post>
            </div>
        ))}
    </div>
)

const BlogPosts = styled(UnstyledBlogPosts)`
    > * + * {
        margin-top: 1.5rem;
    }
`

export default BlogPosts
